var _IndentedStringBuilder_strings, _IndentedStringBuilder_lastValue, _IndentedStringBuilder_invalidateLastValue, _IndentedStringBuilder_indentationLevel;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { empty, newLine } from '../Strings/_consts';
/**
 * Class for building strings that will only concatenate them upon calling toString().
 */
export default class IndentedStringBuilder {
    /**
     * Create a new StringBuilder.
     * @param lines
     */
    constructor(indentationLevel, ...lines) {
        _IndentedStringBuilder_strings.set(this, void 0);
        _IndentedStringBuilder_lastValue.set(this, void 0);
        _IndentedStringBuilder_invalidateLastValue.set(this, void 0);
        _IndentedStringBuilder_indentationLevel.set(this, void 0);
        this.indentationString = "\t";
        __classPrivateFieldSet(this, _IndentedStringBuilder_indentationLevel, indentationLevel, "f");
        __classPrivateFieldSet(this, _IndentedStringBuilder_strings, lines.map(s => ({ indent: __classPrivateFieldGet(this, _IndentedStringBuilder_indentationLevel, "f"), value: s + newLine })), "f");
        __classPrivateFieldSet(this, _IndentedStringBuilder_invalidateLastValue, true, "f");
    }
    /**
     * Appends the value to the builder with a new line afterwards.
     * @param value
     */
    appendLine(value) {
        __classPrivateFieldGet(this, _IndentedStringBuilder_strings, "f").push({ indent: __classPrivateFieldGet(this, _IndentedStringBuilder_indentationLevel, "f"), value: value + newLine });
        __classPrivateFieldSet(this, _IndentedStringBuilder_invalidateLastValue, true, "f");
    }
    /**
     * Clears all values from the StringBuilder.
     */
    clear() {
        __classPrivateFieldGet(this, _IndentedStringBuilder_strings, "f").length = 0;
        __classPrivateFieldSet(this, _IndentedStringBuilder_invalidateLastValue, true, "f");
    }
    /** adds an indent level */
    indent() {
        var _a;
        __classPrivateFieldSet(this, _IndentedStringBuilder_indentationLevel, (_a = __classPrivateFieldGet(this, _IndentedStringBuilder_indentationLevel, "f"), _a++, _a), "f");
    }
    /** Removes the current indent */
    unindent() {
        var _a;
        __classPrivateFieldSet(this, _IndentedStringBuilder_indentationLevel, (_a = __classPrivateFieldGet(this, _IndentedStringBuilder_indentationLevel, "f"), _a--, _a), "f");
        if (__classPrivateFieldGet(this, _IndentedStringBuilder_indentationLevel, "f") < 0) {
            __classPrivateFieldSet(this, _IndentedStringBuilder_indentationLevel, 0, "f");
        }
    }
    /**
     * Returns a string representation of the StringBuilder.
     */
    toString() {
        if (__classPrivateFieldGet(this, _IndentedStringBuilder_invalidateLastValue, "f")) {
            __classPrivateFieldSet(this, _IndentedStringBuilder_invalidateLastValue, false, "f");
            return __classPrivateFieldSet(this, _IndentedStringBuilder_lastValue, __classPrivateFieldGet(this, _IndentedStringBuilder_strings, "f")
                .map(sv => [this.indentationString.repeat(sv.indent), sv.value])
                .reduce((p, c) => [p, ...c].join(empty), empty), "f");
        }
        else {
            return __classPrivateFieldGet(this, _IndentedStringBuilder_lastValue, "f") || empty;
        }
    }
}
_IndentedStringBuilder_strings = new WeakMap(), _IndentedStringBuilder_lastValue = new WeakMap(), _IndentedStringBuilder_invalidateLastValue = new WeakMap(), _IndentedStringBuilder_indentationLevel = new WeakMap();
